export const Logo = ({ className = "", iconClass = "h-8 w-8", textClass = "text-lg", showText = true }) => (
  <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <img src="/schq-mark-transparent.png" alt="SiteControlHQ" className={iconClass} />
    {showText && (
      <span className={`font-display font-bold leading-none tracking-tight ${textClass}`}>
        <span className="text-white">SiteControl</span>
        <span className="text-amber-500">HQ</span>
      </span>
    )}
  </span>
);

export default Logo;
